import { useQuery } from 'react-query';
import { queryGet } from './fetch';
import { Account } from './auth';
import { Organization } from './organization';

export interface Client {
  id: string;
  phoneNumber: string;
  account: Account;
  ownedOrganizations: Organization[];
  organizations: Organization[];
  isSsoAccount: boolean;
  deletedAt?: string;
  accountId: string;
  jobTitle: string;
}

export const useClient = (id?: string) => {
  return useQuery(['clients', id], queryGet(`/clients/${id}`), {
    enabled: !!id,
  });
};
